import {
  ContactField,
  fetchContactFields,
} from 'src/editor/api/contact-fields-api'
import { BaseQueryWithValidationClass } from 'src/editor/api/queries/utils/query-with-validation-class'

class ContactFieldsQueryClass extends BaseQueryWithValidationClass<
  [],
  ContactField[]
> {
  queryFn = fetchContactFields
  getQueryKey = () => ['contactFields'] as const
  options = {
    staleTime: 1000 * 60 * 60, // one hour
  }
}

export const contactFieldsQuery = new ContactFieldsQueryClass()
